import React, { Component } from 'react'
import { CaseData } from '../apis/inventoryCase.api'
import ContentAside from '../components/ContentAside'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ItemCard from '../components/ItemCard'
import QuantityTransferForm from '../partials/QuantityTransferForm/QuantityTransferForm'

interface QuantityTransferProps {}

interface QuantityTransferState {
  sourceCase: CaseData | null
}

export default class QuantityTransfer
  extends Component<QuantityTransferProps, QuantityTransferState> {
  constructor (props: QuantityTransferProps) {
    super(props)
    this.state = {
      sourceCase: null
    }
    this.handleSourceCaseChange = this.handleSourceCaseChange.bind(this)
    this.handleResetForm = this.handleResetForm.bind(this)
  }

  get itemCard () {
    const { sourceCase } = this.state
    return sourceCase && sourceCase.pallet && sourceCase.pallet.item &&
      <ItemCard
        code={sourceCase.pallet.item.code}
        description={sourceCase.pallet.item.description}
        cpp={sourceCase.pallet.item.cpp}
        qpc={sourceCase.pallet.item.qpc}
        availableQuantitesOnCase={sourceCase.quantity} />
  }

  handleSourceCaseChange (sourceCase: CaseData | null) {
    this.setState({ sourceCase })
  }

  handleResetForm () {
    this.setState({ sourceCase: null })
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <QuantityTransferForm
            onSourceCaseChange={this.handleSourceCaseChange}
            onResetForm={this.handleResetForm} />
        </ContentMain>
        <ContentAside layout="oneThird">
          {this.itemCard}
        </ContentAside>
      </ContentLayout>
    )
  }
}
